var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w-full flex justify-center"},[_c('a-button',{staticClass:"w-full font-medium btn-wrap",attrs:{"disabled":!_vm.action.action.fail_variants.length},on:{"click":function($event){_vm.isOpen = true}}},[_vm._v(" "+_vm._s(_vm.$t('send_message_user_input_additional_settings_button_text'))+" ")]),_c('a-modal',{staticClass:"modal-overflow-visible",attrs:{"footer":null,"destroy-on-close":true,"width":_vm.windowWidth > 1100 ? '992px' : '95%',"body-style":{
      paddingTop: '40px'
    },"centered":""},model:{value:(_vm.isOpen),callback:function ($$v) {_vm.isOpen=$$v},expression:"isOpen"}},[_c('switch-input',{attrs:{"setup":{
        'func': _vm.switchFailTryMaxCount,
        'args': {
          'model': _vm.context,
          'key': 'FailTryMaxCountIsExist',
          'inline': true,
          'prefix': 'flow_send_message_sidebar_',
        }
      }}}),_c('transition',{attrs:{"name":"default-hide","mode":"out-in"}},[(_vm.FailTryMaxCountIsExist)?_c('number-input',{attrs:{"setup":{
          'func': _vm.setFailTryMaxCount,
          'args': {
            'model': _vm.action.action,
            'key': 'fail_try_max_count',
            'inline': true,
            'min': 0,
            'prefix': 'flow_send_message_sidebar_',
          }
        }}}):_vm._e()],1),_c('text-input',{attrs:{"setup":{
        'func': _vm.setPattern,
        'args': {
          'model': _vm.action.action,
          'key': 'pattern',
          'prefix': 'flow_send_message_sidebar_',
        }
      }}}),_c('switch-input',{attrs:{"setup":{
        'func': _vm.setNegate,
        'args': {
          'model': _vm.action.action,
          'key': 'negate',
          'prefix': 'flow_send_message_sidebar_',
        }
      }}}),_c('time-unit-input',{attrs:{"setup":{
        'func': _vm.setInactiveActionTime,
        'args': {
          'model': _vm.action.action.inactive_action,
          'key': 'time',
          'inline': true,
          'prefix': 'flow_inactive_action_',
        }
      }}}),_c('user-input-actions-list',{attrs:{"actions":_vm.action.action.actions,"node-props":_vm.nodeProps,"editor":_vm.editor,"node":_vm.node,"node-sockets-actions":_vm.nodeSocketsActions},on:{"set-actions":_vm.setActions}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }